<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import { h } from 'vue'
  import { mapGetters } from 'vuex'
  import { LicenseManager } from 'ag-grid-enterprise'
  // CP2.4: key moved out of source — injected from the build env (owner-held) via DefinePlugin; never committed.
  LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-074458}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Revolution_Payroll}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{3}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{6_March_2026}____[v3]_[01]_MTc3Mjc1NTIwMDAwMA==35d300ba9dd71f8c19caa82862e8d16e')

  export default {
    name: 'app',
    data () {
      return {
        chromeWarningNotif: null
      }
    },
    methods: {
      /**
       * Determines whether the current browser being used is Chrome
       */
      checkIfBrowserIsChrome () {
        return !!window.chrome && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
      },
      /**
       * Warn user that navigating away while saving will cause data loss
       * @param event
       * @return {string}
       */
      warnUser (event) {
        if (this.shouldWarnUser) {
          let confirmationMsg = 'Refreshing this page may cause data loss'
          event.returnValue = confirmationMsg
          return confirmationMsg
        }
      }
    },
    computed: {
      ...mapGetters({
        shouldWarnUser: 'getIsUserEditingForm'
      })
    },
    created () {
      if (!this.checkIfBrowserIsChrome()) {
        // Vue 3: this.$createElement was removed — use the imported `h`, and Vue-3 flat vnode props
        // (not { attrs: {...} }). Without this the created hook threw "h is not a function" and the whole
        // app failed to mount in any non-Chrome browser.
        this.chromeWarningNotif = this.$message({
          message: h('p', null, [
            h('span', null, 'ProBooks does not currently support this browser. Please use '),
            h('a', { href: 'https://www.google.com/chrome/', target: '_blank' }, 'Chrome'),
            h('span', null, ' for an optimal experience.')
          ]),
          type: 'warning',
          duration: 0,
          showClose: true
        })
      } else {
        if (this.chromeWarningNotif) {
          this.chromeWarningNotif.close()
          this.chromeWarningNotif = null
        }
      }
    },
    mounted () {
      window.addEventListener('beforeunload', this.warnUser)
    },
    beforeUnmount () {
      window.removeEventListener('beforeunload', this.warnUser)
    }
  }
</script>

<style>
#app {
  font-family: "Roboto Condensed", "Helvetica", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}
@import 'ag-grid-community/styles/ag-grid.css';
@import 'ag-grid-community/styles/ag-theme-balham.css';

</style>
